<template>
    <app-data-table
        :fields="fields"
        :items="data.data || []"
        @sort="onSort"
        :current-page="parseInt(data.current_page) || 1"
        :last-page="parseInt(data.last_page) || 1"
        :from="parseInt(data.from) || 0"
        :to="parseInt(data.to) || 0"
        :total="parseInt(data.total) || 0"
        :per-page="parseInt(data.per_page) || 15"
        :on-change-page="onChangePage"
    >
        <template slot="image" slot-scope="{ item }">
            <div class="item-image-cell" v-if="item.image">
                <img 
                    :src="item.image" 
                    alt="Imagen del item"
                    class="item-thumbnail"
                    @click="showImageModal(item.image)"
                />
            </div>
            <span v-else class="text-muted">
                <i class="fa fa-image"></i> Sin imagen
            </span>
        </template>

        <template slot="category.name" slot-scope="{ item }">
            {{ formatCategoryName(item.category.name, item.category.slug) }}
        </template>

        <template slot="unit_price" slot-scope="{ item }">
            {{ formatCurrency(item.unit_price, item.currency) }}
        </template>

        <template slot="status" slot-scope="{ item }">
            <span :class="item.status ? 'badge badge-success' : 'badge badge-danger'">
                {{ item.status ? 'Activo' : 'Inactivo' }}
            </span>
        </template>

        <template slot="actions" slot-scope="{ item }">
            <b-button variant="primary" size="sm" v-if="userCan('update-items')" @click="onEdit(item)">
                <i class="fa fa-edit" aria-hidden="true"></i>
            </b-button>
            <b-button variant="danger" size="sm" v-if="userCan('delete-items')" @click="onDelete(item)">
                <i class="fa fa-trash" aria-hidden="true"></i>
            </b-button>
        </template>
    </app-data-table>
</template>
<script>
import { mixin } from '../../../../mixin';

export default {
    mixins: [mixin],
    data() {
        return {
            fields: [
                {
                    key: 'image',
                    label: 'Imagen',
                    sortable: false,
                    thClass: 'text-center',
                    tdClass: 'text-center'
                },
                {
                    key: 'name',
                    label: 'Nombre',
                    sortable: true
                },
                {
                    key: 'reference',
                    label: 'Referencia',
                    sortable: true
                },
                {
                    key: 'category.name',
                    label: 'Categoría',
                    sortable: false
                },
                {
                    key: 'unit_price',
                    label: 'Precio Unitario',
                    sortable: true
                },
                {
                    key: 'unit_type',
                    label: 'Tipo de Unidad',
                    sortable: true
                },
                {
                    key: 'currency',
                    label: 'Moneda',
                    sortable: true
                },
                {
                    key: 'status',
                    label: 'Estado',
                    sortable: true
                },
                {
                    key: 'actions',
                    label: 'Acciones'
                }
            ],
            selectedImage: null
        };
    },
    props: {
        data: {
            type: Object,
            required: true
        },
        onEdit: {
            type: Function,
            required: true
        },
        onDelete: {
            type: Function,
            required: true
        },
        onChangePage: {
            type: Function,
            required: true
        }
    },
    methods: {
        formatCategoryName(name, slug) {
            const names = {
                slug: name
            };
            return names[slug] || name;
        },
        formatCurrency(amount, currency) {
            return new Intl.NumberFormat('es-CO', {
                style: 'currency',
                currency: currency
            }).format(amount);
        },
        onSort(ctx) {
            this.$emit('sort', ctx);
        },
        showImageModal(imageUrl) {
            window.open(imageUrl, '_blank');
        }
    }
};
</script>
<style scoped lang="scss">
.item-image-cell {
    .item-thumbnail {
        width: 60px;
        height: 60px;
        object-fit: cover;
        border-radius: 6px;
        cursor: pointer;
        transition: transform 0.2s ease;
        box-shadow: 0 2px 4px rgba(0,0,0,0.1);
        
        &:hover {
            transform: scale(1.1);
            box-shadow: 0 4px 8px rgba(0,0,0,0.2);
        }
    }
}
</style>
